// extracted by mini-css-extract-plugin
module.exports = {"menu":"_924a7","visible":"_4788e","links":"_51183","selected":"adc2a","button":"aa9dc","profile":"_8255a","user":"_45abd","username":"_15f0f","debug":"_5149f"};